import "./App.css";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import Login from "./Component/Login/login";
import PrivateRoute from "./PrivateRoute";
//import ForgotPassword from "./Component/Login/forgotpassword";
// Dashboard Components
import SuperAdminDashboard from "./Component/Dashboard/SuperAdmin/SuperAdminDashboard";
import TeacherDashboard from "./Component/Dashboard/TeacherDashboard/TeacherDashboard";
import DashContent from "./Component/Dashboard/StudentDashboard/Dashboard/DashContent";
import AdminDashboard from "./Component/Dashboard/AdminDashboard/AdminDashContent/AdminHome/AdminHome.js";
import StudentListadmin from "./Component/Dashboard/AdminDashboard/AdminDashContent/AdminStudent/AdminStudent.js"
import AdminStudentPerformance from "./Component/Dashboard/AdminDashboard/AdminDashContent/AdminStudent/AdminStudentPerformance.js"

// Sidebar Components
import Sidebar from "./Component/Dashboard/StudentDashboard/Sidebar/SideBar";
import SuperAdminSidebar from "./Component/Dashboard/SuperAdmin/Superadmincom/SuperAdminSidebar";
import TeacherSidebar from "./Component/Dashboard/TeacherDashboard/TeacherSidebar/TeacherSidebar";

// Master Components
import Role from "./Component/Master/Role/RoleMaster";
import User from "./Component/Master/UserMaster/UserMaster";
import Course from "./Component/Master/CourseMaster/CourseMastercreation";
import CourseSubdetails from "./Component/Master/CourseMaster/CourseSubdetails";
import CourseDetails from "./Component/Master/CourseMaster/CourseDetails";
import Assignmentdetails from "./Component/Master/Assignment/AssignmentMaster";
import QuestionBank1 from "./Component/Master/QuestionBank/QuestionBank";
import SchoolMaster from "./Component/Master/SchoolMaster/SchoolMaster";
import AssignmentQuestions from "./Component/Master/Assignment/AssignmentQuestion";
import QuizMaster from "./Component/Master/QuizMaster/QuizMaster";
import Class from "./Component/Master/ClassMaster/ClassMaster";
import Projects from "./Component/Master/Projects/ProjectMaster";
import QuizQuestion from "./Component/Master/QuizMaster/QuizQuestion";
import Banner from "./Component/Master/Banner/Banner";
import Badge from "./Component/Master/Badges/Badges";
import CourseM from "./Component/Master/Mapping/CourseMapping";
import TeacherclaM from "./Component/Master/Mapping/TeacherClassMapping";

// Student Components
import StudentAssignment from "./Component/Assignment/StudentAssignment/StudentAssignment";
import StudentProjects from "./Component/Projects/StudentProjects";
import StudentQuiz from "./Component/StudentQuiz/StudentQuiz";
import QuestionBank from "./Component/StudentQuiz/QuestionBank";
import Test from "./Component/Test/Test";
import Profile from "./Component/Profile/Profile";
import AProfile from "./Component/Profile/AdminProfile";
import CourseContent from "./Component/Course/StudentCourse/CourseContent";
import StudentCourseDetails from "./Component/Course/StudentCourse/CourseDetails";
import QuizContent from "./Component/StudentQuiz/QuizContent";
import QuizDetails from "./Component/StudentQuiz/QuizDetails";
import ProjectDetail from "./Component/Projects/StudentProjectDetails";
import QuizCompletionPage from "./Component/StudentQuiz/QuizCompletionPage";

// Teacher Components
import Teacherprojects from "./Component/Dashboard/TeacherDashboard/TeacherProject";
import TeacherProjectDetails from "./Component/Dashboard/TeacherDashboard/TeacherProjectDetails";
import StudentList from "./Component/Dashboard/TeacherDashboard/StudentList";
import CourseProgress from "./Component/Dashboard/TeacherDashboard/CourseProgess";
import TeacherProfile from "./Component/Dashboard/TeacherDashboard/TeacherProfile/TeacherProfile";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import StudentProfile from "./Component/StudentProfile/Profile";
import CourseList from "./Component/Course/StudentCourse/CourseList";
// src/Component/Dashboard/TeacherDashboard/CourseList.js
import TeacherCourseList from "./Component/Dashboard/TeacherDashboard/CourseList.js";
// src/Component/Dashboard/TeacherDashboard/CourseDetails.js
import TeacherCourseDeatils from "./Component/Dashboard/TeacherDashboard/CourseDetails.js";
// src/Component/Dashboard/TeacherDashboard/CourseContent.js
import TeacherCourseContent from "./Component/Dashboard/TeacherDashboard/CourseContent.js";
import UserPerformance from "./Component/Dashboard/TeacherDashboard/UserPerformance";
import { ParentalInfoCheck } from "./Component/context/ParentalInfoCheck";
import { WhileQuizNavigationCheck } from "./Component/context/WhileQuizNavigationCheck";
import StudentAssessment from "./Component/StudentAssessment/StudentAssessment";
import AssessmentContent from "./Component/StudentAssessment/AssessmentContent";
import AssignmentContent from "./Component/StudentAssignment/AssignmentContent";
import SSPIMaster from "./Component/Master/SSPI/SspiMaster.js";
import SSPIQuestion from "./Component/Master/SSPI/SspiQuestion.js";
import CourseSubcription from "./Component/Master/Mapping/CourseSubcription.js";
import AdminSummary from "./Component/Dashboard/AdminDashboard/AdminDashContent/AdminSummary/AdminSummary.js";
import SchoolSuccessFactor from "./Component/Master/SSPI/SchoolSuccessFactor.jsx";
const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decoded = JSON.parse(atob(token.split(".")[1]));
    return decoded.exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
};

const getDefaultRoute = (role) => {
  const roleRoutes = {
    SuperAdmin: "/SuperAdminDashboard",
    Admin: "/adminDashboard",
    Teacher: "/TeacherDashboard",
    Student: "/StudentDashboard",
  };
  return roleRoutes[role] || "/login";
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role"));

  useEffect(() => {
    const validateTokenAndRedirect = () => {
      const storedToken = localStorage.getItem("token");
      const storedRole = localStorage.getItem("role");

      if (!storedToken || !isTokenValid(storedToken)) {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        setToken(null);
        setRole(null);

        if (location.pathname !== "/login") {
          navigate("/login", { replace: true });
        }
      } else {
        setToken(storedToken);
        setRole(storedRole);

        // Redirect to default route if on login page when already authenticated
        if (location.pathname === "/login" || location.pathname === "/") {
          navigate(getDefaultRoute(storedRole), { replace: true });
        }
      }
    };

    validateTokenAndRedirect();

    // Handle back button navigation
    const handlePopState = () => {
      if (
        token &&
        (location.pathname === "/login" || location.pathname === "/")
      ) {
        navigate(getDefaultRoute(role), { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate, location, token, role]);

  // State management for various data
  const [assignmentData, setAssignmentData] = useState({
    studentAssignmentMaster: {},
    studentAssignmentQuestions: {},
  });

  const [courseData, setCourseData] = useState({
    studentCourseMaster: {},
    studentCourseData: {},
    studentCourseSubDetails: {},
    studentCourseDetails: {},
  });

  const [quizData, setQuizData] = useState({
    studentQuizMaster: {},
    studentQuizData: {},
    studentQuizQuestions: {},
  });

  const [projectData, setProjectData] = useState({
    studentProjectMaster: {},
  });

  const [bannerData, setBannerData] = useState({
    studentBannerData: {},
  });
  const theme = createTheme({
    palette: {
      primary: {
        main: "#1976d2", // Blue
        light: "#42a5f5",
        dark: "#1565c0",
      },
      secondary: {
        main: "#F85006", // Purple
      },
      error: {
        main: "#d32f2f", // Red
      },
      warning: {
        main: "#ed6c02", // Orange
      },
      info: {
        main: "#0288d1", // Light blue
      },
      success: {
        main: "#2e7d32", // Green
      },
      background: {
        default: "#f5f5f5", // Light gray
        paper: "#ffffff", // White
      },
      text: {
        primary: "rgba(0, 0, 0, 0.87)", // Almost black
        secondary: "rgba(0, 0, 0, 0.6)",
        disabled: "rgba(0, 0, 0, 0.38)",
      },
    },
    typography: {
      fontFamily: '"Poppins", "Arial", sans-serif',
      h1: {
        fontSize: "2rem",
        fontWeight: 500,
        lineHeight: 1.2,
      },
      h2: {
        fontSize: "1.5rem",
        fontWeight: 500,
        lineHeight: 1.3,
      },
      h3: {
        fontSize: "1.1rem",
        fontWeight: 600,
        letterSpacing: "0",
      },
      h4: {
        fontSize: "1rem",
        fontWeight: 500,
        color: "#000000",
      },
      h5: {
        fontSize: "0.9rem",
        fontWeight: 500,
        lineHeight: "0.9rem",
      },
      h6: {
        fontSize: "0.9rem",
        fontWeight: 400,
      },
      subtitle1: {
        fontSize: "0.8rem",
        fontWeight: 400,
        lineHeight: "0.8rem",
      },
      subtitle2: {
        fontSize: "0.75rem",
        fontWeight: 500,
        color: "#F85006",
      },
      body1: {
        fontSize: "1rem",
        fontWeight: 400,
      },
      body2: {
        fontSize: "0.85rem",
        fontWeight: 300,
        lineHeight: "0.875rem",
      },
      button: {
        fontSize: "0.875rem",
        fontWeight: 500,
        textTransform: "none", // if you want buttons to not be uppercase
      },
      caption: {
        fontSize: "0.75rem",
        fontWeight: 400,
        color: "#616161",
      },
      overline: {
        fontSize: "0.625rem",
        fontWeight: 400,
        textTransform: "uppercase",
      },
    },
    spacing: 8, // This sets the base spacing unit (8px)
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* This is a context for parents information check, if its empty */}
      <ParentalInfoCheck>
        <WhileQuizNavigationCheck>
          <Routes>
            {/* Public Routes */}
            
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Student Routes */}
            <Route
              path="/StudentDashboard"
              element={
                <PrivateRoute roles={["Student"]}>
                  <DashContent
                    assignmentData={assignmentData}
                    setAssignmentData={setAssignmentData}
                    courseData={courseData}
                    setCourseData={setCourseData}
                    quizData={quizData}
                    setQuizData={setQuizData}
                    projectData={projectData}
                    setProjectData={setProjectData}
                    bannerData={bannerData}
                    setBannerData={setBannerData}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/StudentProfile"
              element={
                <PrivateRoute roles={["Student"]}>
                  <StudentProfile />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/CourseList"
              element={
                <PrivateRoute roles={["Student"]}>
                  <CourseList
                    courseData={courseData}
                    setCourseData={setCourseData}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/Course"
              element={
                <PrivateRoute roles={["Student"]}>
                  <StudentCourseDetails
                    courseData={courseData}
                    setCourseData={setCourseData}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/Course/CourseContent"
              element={
                <PrivateRoute roles={["Student"]}>
                  <CourseContent
                    courseData={courseData}
                    setCourseData={setCourseData}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/Quiz"
              element={
                <PrivateRoute roles={["Student"]}>
                  <QuizDetails quizData={quizData} setQuizData={setQuizData} />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/Quiz/QuizContent"
              element={
                <PrivateRoute roles={["Student"]}>
                  <QuizContent quizData={quizData} setQuizData={setQuizData} />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/Quiz/QuizContent/QuizCompletionPage"
              element={
                <PrivateRoute roles={["Student"]}>
                  <QuizCompletionPage />
                </PrivateRoute>
              }
            />
            {/* -------- ASSIGNMENT ROUTES STARTS HERE -------- */}
            <Route
              path="/StudentDashboard/AssignmentContent"
              element={
                <PrivateRoute roles={["Student"]}>
                  <AssignmentContent />
                </PrivateRoute>
              }
            />
            {/* -------- ASSIGNMENT ROUTES ENDS HERE -------- */}

            {/* -------- Internal Assessment Routes STARTS HERE -------- */}
            <Route
              path="/StudentDashboard/Assessment"
              element={
                <PrivateRoute roles={["Student"]}>
                  <StudentAssessment />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentDashboard/Assessment/AssessmentContent"
              element={
                <PrivateRoute roles={["Student"]}>
                  <AssessmentContent />
                </PrivateRoute>
              }
            />
            {/* -------- Internal Assessment Routes ENDS HERE -------- */}
            <Route
              path="/StudentDashboard/Projects"
              element={
                <PrivateRoute roles={["Student"]}>
                  <StudentProjects
                    projectData={projectData}
                    setProjectData={setProjectData}
                  />
                </PrivateRoute>
              }
            />
            {/* Other Student Routes... */}

            {/* Teacher Routes */}
            <Route
              path="/TeacherDashboard"
              element={
                <PrivateRoute roles={["Teacher"]}>
                  <TeacherDashboard />
                </PrivateRoute>
              }
            />

            {/* Admin Routes */}
            <Route
              path="/AdminDashboard"
              element={
                <PrivateRoute roles={["Admin"]}>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />


            <Route
              path="/AdminSummary"
              element={
                <PrivateRoute roles={["Admin"]}>
                  <AdminSummary />
                </PrivateRoute>
              }
            />

            <Route
              path="/StudentListadmin"
              element={
                <PrivateRoute roles={["Admin"]}>
                  <StudentListadmin />
                </PrivateRoute>
              }
            />

            <Route
              path="/AdminStudentPerformance"
              element={
                <PrivateRoute roles={["Admin"]}>
                  <AdminStudentPerformance />
                </PrivateRoute>
              }
            />

            {/* Super Admin Routes */}
            <Route
              path="/SuperAdminDashboard"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <SuperAdminDashboard />
                </PrivateRoute>
              }
            />

            {/* Sidebar Routes */}
            <Route
              path="/studentSidebar"
              element={
                <PrivateRoute roles={["Student"]}>
                  <Sidebar />
                </PrivateRoute>
              }
            />

            {/* Master Routes */}
            <Route
              path="/RoleMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Role />
                </PrivateRoute>
              }
            />
            <Route
              path="/UserMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <User />
                </PrivateRoute>
              }
            />
            <Route
              path="/CourseMastercreation"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Course />
                </PrivateRoute>
              }
            />
            <Route
              path="/CourseSubdetails"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <CourseSubdetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/CourseDetails"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <CourseDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/AssignmentMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Assignmentdetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/QuestionBank"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <QuestionBank1 />
                </PrivateRoute>
              }
            />
            <Route
              path="/SchoolMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <SchoolMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Banner"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Banner />
                </PrivateRoute>
              }
            />
            <Route
              path="/Badges"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Badge />
                </PrivateRoute>
              }
            />
            <Route
              path="/CourseMapping"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <CourseM />
                </PrivateRoute>
              }
            />
            <Route
              path="/AssignmentQuestion"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <AssignmentQuestions />
                </PrivateRoute>
              }
            />
            <Route
              path="/QuizMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <QuizMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/ClassMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Class />
                </PrivateRoute>
              }
            />
            <Route
              path="/ProjectMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <Projects />
                </PrivateRoute>
              }
            />
            <Route
              path="/QuizQuestion"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <QuizQuestion />
                </PrivateRoute>
              }
            />
             <Route
              path="/SspiMaster"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <SSPIMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/SchoolSuccessFactor"
              element={
                <PrivateRoute roles={["SuperAdmin","Admin"]}>
                  <SchoolSuccessFactor />
                </PrivateRoute>
              }
            />
            <Route
              path="/CourseSubcription"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <CourseSubcription/>
                </PrivateRoute>
              }
            />
             <Route
              path="/SspiQuestion"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <SSPIQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/SuperAdminSidebar"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <SuperAdminSidebar />
                </PrivateRoute>
              }
            />
            <Route
              path="/StudentAssignment"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <StudentAssignment />
                </PrivateRoute>
              }
            />
            {/* Other Master Routes... */}
            <Route
              path="/QuestionBank"
              element={
                <PrivateRoute roles={["SuperAdmin", "Student"]}>
                  <QuestionBank />
                </PrivateRoute>
              }
            />
            {/* Teacher Routes... */}
            <Route
              path="/TeacherSidebar"
              element={
                <PrivateRoute roles={["SuperAdmin"]}>
                  <TeacherSidebar />
                </PrivateRoute>
              }
            />
            <Route
              path="/project/:id"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <ProjectDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/Teacherprojects"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <Teacherprojects />
                </PrivateRoute>
              }
            />
            <Route
              path="/UserPerformance"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <UserPerformance />
                </PrivateRoute>
              }
            />
            <Route
              path="/TeacherProfile"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <TeacherProfile />
                </PrivateRoute>
              }
            />
            <Route
              // path="/Teacherproject/:id"
              path="/TeacherprojectInfo"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <TeacherProjectDetails />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/Teacherproject/:id"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <TeacherProjectDetails />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/StudentList"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <StudentList />
                </PrivateRoute>
              }
            />
            <Route
              path="/CourseProgress"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher", "Student"]}
                >
                  <CourseProgress />
                </PrivateRoute>
              }
            />
            {/* --------------------------- TEACHER COURES SECTION ROUTES --------------------------- */}
            <Route
              path="/TeacherCourseList"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher"]}
                >
                  <TeacherCourseList />
                </PrivateRoute>
              }
            />
            <Route
              path="/TeacherCourseDetails"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher"]}
                >
                  <TeacherCourseDeatils />
                </PrivateRoute>
              }
            />
            <Route
              path="/TeacherCourseContent"
              element={
                <PrivateRoute
                  roles={["SuperAdmin", "Admin", "Teacher"]}
                >
                  <TeacherCourseContent />
                </PrivateRoute>
              }
            />
            {/* --------------------------- TEACHER COURES SECTION ROUTES --------------------------- */}
            <Route
              path="/TeacherClassMapping"
              element={
                <PrivateRoute roles={["SuperAdmin", "Admin"]}>
                  <TeacherclaM />
                </PrivateRoute>
              }
            />
            {/* Shared Components */}
            <Route
              path="/Profile"
              element={
                <PrivateRoute roles={["SuperAdmin", "Teacher", "Student"]}>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/AdminProfile"
              element={
                <PrivateRoute roles={["Admin"]}>
                  <AProfile />
                </PrivateRoute>
              }
            />
            {/* Catch-all Route */}
            <Route
              path="*"
              element={
                <Navigate
                  to={token ? getDefaultRoute(role) : "/login"}
                  replace
                />
              }
            />
          </Routes>
        </WhileQuizNavigationCheck>
      </ParentalInfoCheck>
    </ThemeProvider>
  );
}

export default App;
